import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import changelog from '../../CHANGELOG.md?raw'

export interface ChangeLogProps extends HTMLAttributes<HTMLDivElement> {}

export default function ChangeLog({ ...props }: ChangeLogProps) {
	return (
		<div
			css={css`
				text-align: initial;
				height: 100%;
				overflow: hidden auto;

				&::-webkit-scrollbar {
					display: none;
				}
			`}
		>
			<Markdown
				remarkPlugins={[remarkGfm]}
				css={css`
					font-size: 16px;

					h1 {
						&:not(:first-of-type) {
							margin-top: 3em;
						}
					}

					h3 {
						margin: 1em 0 0.5em;
					}

					ul {
						margin: 0;
						padding-left: 1em;
					}
				`}
			>
				{changelog}
			</Markdown>
		</div>
	)
}
